import Icon, { IconProps } from './Icon';

import BookmarkIcon from '../../../assets/icons/bookmark.svg?react';

const Bookmark: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <BookmarkIcon />
    </Icon>
  );
};

export default Bookmark;
